import { LandingButton } from '../LandingButton';

import './styles.scss';

/**
 * LandingAction wraps a call-to-action block and renders a LandingButton
 * below arbitrary content. Extra class can be provided to adjust layout.
 *
 * @param {'bg' | 'en' | 'es' | 'gr' | 'it' | 'pt' | 'ro' | 'espe' | 'escl'} lang — Language key used to localize the CTA button text.
 * @param {string} [className] — Additional CSS class for the action wrapper.
 * @param {boolean} disable — When true, the action button stays disabled.
 * @param {Function} onClick — Handler for the LandingButton click.
 * @param {string} [btnClassName] — Optional CSS class for the button.
 * @param {string} [textClassName] — Optional CSS class for the animated button text.
 * @param {string} alt — Alt text for the play icon.
 * @param {import('react').ReactNode} children — Content displayed above the button.
 */

export const LandingAction = ({
    lang,
    className,
    onClick,
    disable,
    btnClassName,
    textClassName,
    alt,
    children,
}) => (
    <div className={`landing-action ${className}`}>
        {children}

        <LandingButton
            disabled={disable}
            lang={lang}
            onClick={onClick}
            btnClassName={btnClassName}
            textClassName={textClassName}
            alt={alt}
        />
    </div>
);
